export enum Shape { 
    CIRCLE="circle", 
    RECTANGLE="rectangle", 
    HEXAGON="hexagon", 
    RHOMBUS="rhombus", 
    SIMPLE_RECTANGLE="simple_rectangle", 
    SIMPLE_CIRCLE="simple_circle",
    SIMPLE_RHOMBUS="simple_rhombus",
    INFO_RECTANGLE="info_rectangle",
    SIMPLE_HEXAGON="simple_hexagon",
    SWIM_LANE_CONTAINER="swim_line_container",
    DOTTED_AREA="dotted_area",
    RECTANGLE_AREA="rectangle_area",
    PEOPLE_HEX="people_hex",
    SIMPLE_AREA="simple_area",
    SWIM_LANE_DOTTED="swim_line_dotted",
    ROMBOID_LEFT="romboid_left",
    ROMBOID_RIGHT="romboid_right",
    SOLID_TEXT_RECTANGLE="solid_text_rectangle",
    TRAPEZIUM_LEFT="trapezium_left",
    TRAPEZIUM_RIGHT="trapezium_right",
}